<template>
  <div>
    <login-widget-modal :device="device" :editing="editing" :site="site" :model="site?.loginSetting" @login="onLogin" />
    <mission-center-widget-modal ref="$mission" :editing="editing" :site="site" :model="site?.missionCenterSetting" />
    <portal-target v-if="!editing" name="dialog-collection" />
  </div>
</template>

<script>
import LoginWidgetModal from '../widgets/loginSetting/index'
import MissionCenterWidgetModal from '~/site/widgets/missionCenterSetting/index.vue'
import {PageEnum} from "~/enums/pageEnum";

export default {
  name: "SiteModals",
  components: {
    LoginWidgetModal,
    MissionCenterWidgetModal
  },
  props: {
    site: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      default: 'desktop'
    }
  },
  computed: {
    supportDialog() {
      return !this.$route.fullPath.includes(PageEnum.SHOP_CART)
    }
  },
  methods: {
    onLogin() {
      this.$refs?.$mission.init()
    }
  }
}
</script>

<style lang="less" scoped>

</style>
